export default "__VITE_ASSET__DGVjaPim__"